<template>
  <div :data-theme="theme">
    <NuxtLoadingIndicator />
    <slot />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
const THEMES = [
  'light',
  'dark',
];
export default {
  setup () {
    const theme = ref('light');
    watch(theme, (value) => {
      localStorage.setItem('daisyui-theme', value);
    });
    onMounted(() => {
      // theme.value = localStorage.getItem('daisyui-theme') || 'light';
      theme.value = 'light';
    });
    return {
      theme,
      themes: THEMES,
    };
  },
};
</script>
